import React from "react";
import { Badge, Text, Table } from "@mantine/core";
import moment from "moment";
import { useCellRender } from "../hooks/useCellRender";

const ApprovalFundAcknowledgementList = ({ form }) => {
  const [cellRender] = useCellRender();
  const needQuizAcknowledge = form?.values?.needQuizAcknowledge !== false;
  const acknowledgements = (form?.values?.acknowledgements ?? []).filter(
    (item) => item?.approved
  );

  if (!needQuizAcknowledge) {
    return (
      <Text size="sm" color="dimmed">
        Quiz acknowledgement is not required for this list.
      </Text>
    );
  }

  if (!acknowledgements.length) {
    return (
      <Text size="sm" color="dimmed">
        No users have completed the quiz yet.
      </Text>
    );
  }

  return (
    <Table striped highlightOnHover withBorder>
      <thead>
        <tr>
          <th>User</th>
          <th>Staff ID</th>
          <th>Passed at</th>
          <th>Approved to Sell</th>
        </tr>
      </thead>
      <tbody>
        {acknowledgements.map((item, index) => (
          <tr key={item._id ?? item.user?._id ?? index}>
            <td>{cellRender.User(item.user)}</td>
            <td>{item.user?.staffId ?? "--"}</td>
            <td>
              {item.passedAt
                ? moment(item.passedAt).format("YYYY-MM-DD HH:mm")
                : "--"}
            </td>
            <td>
              <Badge color="green">Allowed</Badge>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ApprovalFundAcknowledgementList;
